import { render, staticRenderFns } from "./ResourceConstructionTypesChart.vue?vue&type=template&id=773ec38c&scoped=true"
import script from "./ResourceConstructionTypesChart.vue?vue&type=script&lang=js"
export * from "./ResourceConstructionTypesChart.vue?vue&type=script&lang=js"
import style0 from "./ResourceConstructionTypesChart.vue?vue&type=style&index=0&id=773ec38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ec38c",
  null
  
)

export default component.exports